import { FileUploadType } from "@fixa/file-upload";
import { useQuery } from "@tanstack/react-query";
import { getWriteSignedUrlsQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import {
  getWriteSignedUrls,
  NO_WRITE_SIGNED_URLS,
} from "@coworker/apprestructured/src/task-management/services/uploads.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

export function useWriteSignedUrls(
  fileNames: string[],
  uploadType: FileUploadType
) {
  return useQuery({
    queryKey: getWriteSignedUrlsQueryKey(fileNames, uploadType),
    queryFn: () => getWriteSignedUrls(fileNames, uploadType),
    refetchInterval: 10 * INTERVAL.MINUTE, // The signed urls are valid for 15 minutes
    initialData: NO_WRITE_SIGNED_URLS,
  });
}
